import { HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppConfigService } from './core/services/app-config.service';
import { AppTranslateHttpLoader } from './core/services/app-translate-http-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { loadCoreDependencies } from './core/services/app-initializers';
import { SharedModule } from './shared/shared.module';
import { LayoutModule } from './layout/layout.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: { provide: TranslateLoader, deps: [HttpClient], useClass: AppTranslateHttpLoader },
    }),
    SharedModule,
    BsDropdownModule.forRoot(),
    LayoutModule,
  ],
  providers: [
    { provide: APP_INITIALIZER, useFactory: loadCoreDependencies, deps: [AppConfigService, Injector], multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
